import React, { ReactElement } from 'react';

import COLORS from '~/constants/colors';

import { RendererProps } from '../../models';
import { getPx } from '../../helpers';

function Stopwatch({ entity }: RendererProps): ReactElement {
  const pos = entity.getPos();
  const time = Math.min(Math.round(entity.time), 99999999);

  // Styling
  const lateralPadding = entity.dims.w / 22;
  const shiftSpace = 1 + lateralPadding;
  const stopwatchStyle = {
    position: 'absolute' as const,
    width: getPx(entity.dims.w),
    height: getPx(entity.dims.h),
    left: getPx(pos.x - entity.dims.w / 2 - shiftSpace),
    top: getPx(pos.y - entity.dims.h / 2),
    padding: `0 ${getPx(lateralPadding)}`,
    lineHeight: getPx(entity.dims.h),
    textAlign: 'right' as const,
    backgroundColor: COLORS.black50,
    borderRadius: getPx(entity.dims.h / 6),
    borderColor: COLORS.black25,
    borderStyle: 'solid',
    borderWidth: getPx(1),
    overflow: 'hidden',
    zIndex: 3,
  };
  const labelStyle = {
    display: 'inline-block',
    position: 'relative' as const,
    marginTop: getPx(-entity.dims.h / 16),
    verticalAlign: 'middle',
    color: COLORS.alto,
    fontSize: getPx(entity.dims.h / 1.6),
  };
  const unitStyle = {
    ...labelStyle,
    marginTop: getPx(-entity.dims.h / 8),
    color: COLORS.cornflower,
  };

  return (
    <div style={stopwatchStyle}>
      <code style={labelStyle}>{time}</code> <span style={unitStyle}>ms</span>
    </div>
  );
}

export default Stopwatch;
